export function MarketingAdminBanner() {
  return null
}
